import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as g from 'src/app/globals';
import {
  SectionTableFilter,
  SectionTableFilterTypes,
} from 'src/app/models/section-table-filter';
import { ExportOptions } from './export-options';
import { ReportParameterDataType } from './report-parameter';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getParameters(reportId: number) {
    return this.http.get(
      `${g.apiBaseUrl}Report/ReportParameters?id=${reportId}`
    );
  }

  getReportDetails(reportId: number) {
    return this.http.get(`${g.apiBaseUrl}Report/ReportDetails?id=${reportId}`);
  }

  getReportData(
    reportId: number,
    parameters: { [key: string]: SectionTableFilter },
    filters: { [key: string]: SectionTableFilter },
    pageSize: number,
    pageIndex: number,
    guid: string,
    sortDirection: string,
    sortField: number
  ) {
    return this.http.post(
      `${g.apiBaseUrl}Report/GetReportData?id=${reportId}&pageSize=${pageSize}&pageIndex=${pageIndex}&reportGuid=${guid}&sortDirection=${sortDirection}&sortField=${sortField}`,
      { filters, parameters }
    );
  }

  UpdateFieldValue(
    Row: number,
    guid: string,
    Column: string,
    Value: any
  ) {
    return this.http.post(`${g.apiBaseUrl}Report/UpdateFieldValue`, {
      Row,
      guid,
      Column,
      Value,
    });
  }

  ExecuteCustomReportAction(
    guid: string,
    ActionName: string
  ) {
    return this.http.post(`${g.apiBaseUrl}Report/ExecuteCustomReportAction`, {
      guid,
      ActionName
    });
  }

  exportReport(
    reportId: number,
    guid: string,
    exportOptions: ExportOptions,
    parameters: { [key: string]: SectionTableFilter }
  ) {
    return this.http.post(`${g.apiBaseUrl}Report/ExportReport`, {
      reportId,
      guid,
      exportOptions,
      parameters,
    });
  }

  getExportedReport(
    requestId: string,
  ) {
    return this.http.post(`${g.apiBaseUrl}Report/GetGeneratedPDF`, {
      requestId,
    });
  }

  getFilterTypeByParameterType(
    dataType: ReportParameterDataType
  ): SectionTableFilterTypes {
    let filterType: SectionTableFilterTypes;
    switch (dataType) {
      case ReportParameterDataType.Field:
        filterType = SectionTableFilterTypes.string;
        break;
      case ReportParameterDataType.Date:
        filterType = SectionTableFilterTypes.date;
        break;
      case ReportParameterDataType.Time:
        filterType = SectionTableFilterTypes.time;
        break;
      case ReportParameterDataType.DropDown:
        filterType = SectionTableFilterTypes.select;
        break;
      case ReportParameterDataType.MultiSelect:
        filterType = SectionTableFilterTypes.multiSelect;
        break;
      case ReportParameterDataType.BusinessPartnerProperties:
        filterType = SectionTableFilterTypes.businessPartnerProperties;
        break;
      case ReportParameterDataType.ItemProperties:
        filterType = SectionTableFilterTypes.itemProperties;
        break;
      case ReportParameterDataType.Number:
        filterType = SectionTableFilterTypes.number;
        break;
    }

    return filterType;
  }
}
